import React , {Component} from 'react';
import Test from '../../assets/images/Banner.jpg';



export default class PatnerDetailsPage extends Component{
    // constructor(){
    //     super()
    // }

    render(){
        return(
            <div className='partner-details-main'>
            <div className='container-fluid'>
            <div className='row'>
            <div className='col-12 col-md-3 col-lg-3'>
            <div className='partner-details-left-div'>
            <div className='partner-details-img-div'>
            <img src={Test} alt="loading..."/>
            </div>
            <div className='partner-details-btn-div'>
            <button type='button' className='btn'>View Website</button>
            </div>
            
            </div>
            
            </div>
            <div className='col-12 col-md-9 col-lg-9'>
            <div className='partner-details-right-div'>
            <div className='partner-details-head-div'>
            <h4>Lively</h4>
            <h3>Health</h3>
            <p>Hearing aids and a doctor's care, delivered to your home</p>
            </div>
            <div className='partner-details-content-div'>
            <h5>About this resource</h5>
            <div className='partner-details-seperation-line'></div>
            <p>Lively provides hearing aids and a doctor’s care from the comfort of your couch. By signing up with Lively, you get the following:</p>
            <div className='partner-details-content-list'>
   
            <h5>Powerful, discreet hearing aids</h5>
            <p>Our nearly-invisible devices provide rich, 360° sound</p>
            </div>
            <div className='partner-details-content-list'>
   
            <h5>On-demand care</h5>
            <p>Get doctor's care & hearing aid adjustments from your couch</p>
            </div>
            <div className='partner-details-content-list'>
   
            <h5>Incredible value</h5>
            <p>Everything you need for better hearing for 1/2 the cost. Financing also available.</p>
            </div>
            <div className='partner-details-content-list'>
   
            <h5>More resources for you</h5>
           
            </div>
            <div className='partner-details-seperation-line'></div>
            <div className="resources-list-content-card">
            <div className="row">
            <div className="col-4 col-md-3 col-lg-3">
            <div className="resources-list-content-card-img">
            <img src={Test} alt="loading...."/>
            </div>
            </div>
            <div className="col-8 col-md-9 col-lg-9">
            <div className="resources-list-content-card-info">
            <h5>Likely</h5>
            <p>Hearing aids and doctor care deliver to your family.</p>
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
            
            </div>
            
            </div>
        )
    }
}

